export default __webpack_public_path__ + "static/media/ctaCreateAccount.5cb0c819.png";